module.exports = __webpack_public_path__ + "img/banner-before.96f3b8ea.jpg";